import { api } from '../lib/api-client.js';

import type {
  AddTeamMemberInput,
  CreateTeamInput,
  UpdateTeamInput,
} from '@sitewise/shared';

export interface TeamSummary {
  id: string;
  orgId: string;
  name: string;
  description: string | null;
  buildingId: string | null;
  memberCount: number;
  leadCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface TeamMemberRow {
  id: string;
  teamId: string;
  userId: string;
  isLead: boolean;
  createdAt: string;
  user: { id: string; name: string; email: string; role: string };
}

export async function listTeams(): Promise<{ teams: TeamSummary[] }> {
  return api('/teams');
}

export async function createTeam(input: CreateTeamInput) {
  return api<{ team: TeamSummary }>('/teams', { method: 'POST', body: input });
}

export async function updateTeam(id: string, input: UpdateTeamInput) {
  return api<{ team: TeamSummary }>(`/teams/${id}`, { method: 'PATCH', body: input });
}

export async function deleteTeam(id: string) {
  await api(`/teams/${id}`, { method: 'DELETE' });
}

export async function listTeamMembers(id: string) {
  return api<{ members: TeamMemberRow[] }>(`/teams/${id}/members`);
}

export async function addTeamMember(id: string, input: AddTeamMemberInput) {
  return api<{ member: Omit<TeamMemberRow, 'user'> }>(`/teams/${id}/members`, {
    method: 'POST',
    body: input,
  });
}

export async function removeTeamMember(id: string, userId: string) {
  await api(`/teams/${id}/members/${userId}`, { method: 'DELETE' });
}
